import _ from 'lodash';
import IApplicationState from 'app/types/state';
import { parseAmount, toTitleCase } from 'app/utils/parsers';

function mapSelect(connectionTypes, n) {
  const sa = connectionTypes.connectionTypesById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return null;
}

export function getConnectionTypesByIdInSelectFormat(connectionTypes): any {
  return _.map(connectionTypes.connectionTypeIds, (n) => mapSelect(connectionTypes, n));
}

export function getCurrentConnectionType(state: IApplicationState): any {
  if (
    state.connectionTypes.connectionTypesById !== undefined
    && state.connectionTypes.currentConnectionTypeId !== undefined
  ) {
    const findConnectionType = state.connectionTypes.connectionTypesById[
      state.connectionTypes.currentConnectionTypeId
    ];
    const currentConnectionType = {
      ...findConnectionType,
    };

    return currentConnectionType;
  }
  return {};
}

export function getCurrentFormConnectionType(state: IApplicationState) {
  return {
    ...getCurrentConnectionType(state),
    ...state.connectionTypes.requestedData,
  };
}

export function getConnectionTypes(state: IApplicationState): any {
  return {
    ...state.connectionTypes,
    currentConnectionType: {
      ...getCurrentConnectionType(state),
    },
  };
}

export function getConnectionTypesByTeamId(state, teamId): any {
  if (
    state.connectionTypes.connectionTypesById !== undefined
    && teamId != null
  ) {
    return _.filter(state.connectionTypes.connectionTypesById, { teamId });
  }
  return {};
}

export function getConnectionTypesByIds(connectionTypesById, tagIds): any {
  if (connectionTypesById !== undefined && tagIds != null) {
    return _.pick(connectionTypesById, tagIds);
  }
  return {};
}

export function getConnectionTypeIdsByTeamId(state, teamId): any {
  if (
    state.connectionTypes.connectionTypesById !== undefined
    && teamId != null
  ) {
    const filtered = _.filter(state.connectionTypes.connectionTypesById, {
      teamId,
    });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}

function parseConnectionTypeTypeText(notificationType) {
  let parsedText = '';
  if (notificationType === 'forfeit-email') {
    parsedText = 'Forfeit Email';
  }
  if (notificationType === 'forfeit-sms') {
    parsedText = 'Forfeit SMS';
  }
  return parsedText;
}

function parseConnectionTypeTypeColour(notificationType) {
  const parsedColour = 'grey';

  return parsedColour;
}

function parseConnectionTypeType(status) {
  const statuses = [];
  const colour = parseConnectionTypeTypeColour(status);
  const text = parseConnectionTypeTypeText(status);

  statuses.push({ colour, text });

  return statuses;
}

export function getConnectionTypeSummary(connectionType): any {
  const connectionTypeSummary = {
    id: connectionType.id,
    notificationType: parseConnectionTypeType(connectionType.notificationType),
    name: connectionType.name,
    email: connectionType.email,
    mobile: connectionType.mobile,
  };
  return connectionTypeSummary;
}
